import React from "react";

import { Flex, IconOnePass, Span } from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";

import { ProductPriceAside } from "./ProductPriceAside";
import { ProductPriceItemChildren } from "./ProductPriceItem";
import { ProductPriceMain } from "./ProductPriceMain";
import { ProductPriceParts } from "./ProductPriceParts";

type ProductPriceOnePassProps = {
  price: number;
  hasPromotion?: boolean;
  large?: boolean;
};

export const ProductPriceOnePass = ({
  price,
  hasPromotion,
  large,
}: ProductPriceOnePassProps) => {
  const TextOnePass = styled(Span)`
    transform: translateY(1px);
  `;

  return price ? (
    <Flex flex="1 1 auto" flexDirection="row" flexWrap="nowrap" fontSize="sm">
      <ProductPriceItemChildren alignItems="center">
        <ProductPriceMain
          height="24px"
          hasPromotion={hasPromotion}
          onePassSecondary
          noArrow
          large={large}
        >
          <ProductPriceParts
            color="onePass.textPrimary"
            fontSize="sm"
            price={price}
            normalView
          />
        </ProductPriceMain>

        <ProductPriceAside
          display="flex"
          flex="0 0 auto"
          flexDirection="row"
          flexWrap="nowrap"
          fontSize={hasPromotion ? "0.875rem" : "0.656rem"}
          hasPromotion={hasPromotion}
          backgroundColor="onePass.primary"
          borderColor="onePass.primary"
          height="24px"
          px="2px"
          color="textWhite"
          fontFamily="onePass"
          large={large}
        >
          <TextOnePass
            fontWeight="bold"
            color="inherit"
            fontSize="2xs"
            margin="0 2.5px"
          >
            with
          </TextOnePass>
          <IconOnePass
            height="auto"
            color="textWhite"
            preserveAspectRatio="xMinYMin meet"
            role="img"
            aria-label="OnePass"
            title="OnePass"
            width={large ? "70px" : "48px"}
          />
        </ProductPriceAside>
      </ProductPriceItemChildren>
    </Flex>
  ) : null;
};
